export const messages = {
  en: {
    contractChangeAuditOrders: {
      title: 'Change To-do List',
      contractCode: 'Contract Number',
      contractName: 'Contract Name',
      contractType: 'Contract Type',
      contractStatus: 'Contract Status',
      createTime: 'Create Time',
      operation: 'Operation',
      view: 'View',
      audit: 'Audit',
      finish: 'Finish',
      processEnd: 'Process End'
    },
  },
zh: {
    contractChangeAuditOrders: {
      title: '变更待办单',
      contractCode: '合同编号',
      contractName: '合同名称',
      contractType: '合同类型',
      contractStatus: '合同状态',
      createTime: '创建时间',
      operation: '操作',
      view: '查看',
      audit: '审批',
      finish: '结束',
      processEnd: '处理结束'
    },
  },
  'zh-TW': {
    contractChangeAuditOrders: {
      title: '變更待辦單',
      contractCode: '合同編號',
      contractName: '合同名稱',
      contractType: '合同類型',
      contractStatus: '合同狀態',
      createTime: '創建時間',
      operation: '操作',
      view: '查看',
      audit: '審批',
      finish: '結束',
      processEnd: '處理結束'
    },
  }
}